import "../../styles/modal.css";

export default function AdminDeleteModal({ admin, onClose, onConfirm }) {
  if (!admin) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div
        className="modalCard modalDanger"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modalDangerTitle">Supprimer administrateur</h3>

        <p className="modalDangerText">
          Êtes-vous sûr de vouloir supprimer
          <strong> {admin.firstName} {admin.lastName}</strong> ?
        </p>

        <p className="modalDangerWarning">
          Cette action est irréversible.
        </p>

        <div className="modalActions">
          <button className="btnGhost" onClick={onClose}>
            Annuler
          </button>

          <button
            className="btnDanger"
            onClick={() => onConfirm(admin.id)}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
